import { WarehouseLocationGroupListPage } from "@/features/warehouse-location-group/pages/WarehouseLocationGroupListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/warehouse-location-group/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse_location_group.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseLocationGroupListPage,
});
